import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Row, Col } from 'react-bootstrap';
import { injectIntl } from 'react-intl';

import EntityStateUpdater from 'component/EntityStateUpdater';

import Loader from 'components/layout/Loader';

import Data from 'components/Data';
import Entity from 'components/Entity';

import FormErrors from 'components/forms/FormErrors';
import FormAutocomplete from 'components/forms/FormAutocomplete';
import FormInput from 'components/forms/FormInput';

import { entityMetaMapping } from 'js/constants';

class ClientCarForm extends EntityStateUpdater {
  constructor(props) {
    super(props);

    this.state = {
      entityLoaded: false,
      entityChanged: false,
    };

    this.entity = new Entity();
    // if we get car data from the outside, we can pass it on to our data entity
    const data = props.data || {
      // default car data:
      type: 'own',
      lang: props.appIntl.locale,
    };
    this.entity.setData(data);

    if (props.meta[entityMetaMapping.clientCar] !== undefined && !props.meta[entityMetaMapping.clientCar].pending) {
      this.entity.setMeta(props.meta, entityMetaMapping.clientCar);

      this.state = {
        ...this.state,
        entityLoaded: true,
        entity: this.entity,
      };
    }
  }

  componentDidUpdate = () => {
    const { meta } = this.props;

    if (
      meta[entityMetaMapping.clientCar] !== undefined &&
      !meta[entityMetaMapping.clientCar].pending &&
      !this.entity.getMetaLoaded()
    ) {
      this.entity.setMeta(meta, entityMetaMapping.clientCar);
      if (this.entity.getDataLoaded()) {
        this.setState({ entityLoaded: true, entity: this.entity });
      }
    }
  };

  updateBrand = (fieldName, brand) => {
    this.updateEntityMultiple(['brandId', 'brandName', 'brand'], [brand.id, brand.name, brand], [[], [], ['item']]);
  };

  updateModel = (fieldName, model) => {
    this.updateEntityMultiple(['modelId', 'modelName', 'model'], [model.id, model.name, model], [[], [], ['item']]);
  };

  updateVin = (fieldName, vin) => {
    this.updateEntityMultiple(['vin', 'vin'], [vin, vin], [[], ['item', 'ident']]);
  };

  updateLicensePlateNumber = (fieldName, licensePlateNumber) => {
    this.updateEntityMultiple(
      ['licensePlateNumber', 'licensePlateNumber'],
      [licensePlateNumber, licensePlateNumber],
      [[], ['item', 'ident']]
    );
  };

  formSubmit = e => {
    e.preventDefault();

    this.setState(
      prevState => ({ entity: prevState.entity.validate() }),
      () => {
        const { onSubmit } = this.props;
        const { entity } = this.state;
        if (entity.isValid) {
          onSubmit(entity.processedData);
        }
      }
    );
  };

  render() {
    const {
      intl: { messages },
      formStatus,
    } = this.props;
    const { entity, entityLoaded } = this.state;

    const disabled = formStatus.pending;

    return (
      <Row>
        <Data dataName="clientCar" /> {/* fetch meta data */}
        <Col xs={12}>
          <FormErrors formStatus={formStatus} />

          {entityLoaded ? (
            <form method="post" onSubmit={this.formSubmit}>
              <div className="form-group-attached">
                <FormAutocomplete
                  label={messages.brand}
                  name="brand"
                  value={{ value: entity.getBrandId(), label: entity.getBrandName() }}
                  meta={entity.getBrandIdMetaInformation()}
                  validation={entity.getBrandIdValidationResult()}
                  onChange={this.updateBrand}
                  returnValueObject
                  autocompleteType="brand"
                  disabled={disabled}
                />
                <FormAutocomplete
                  urlFilters={entity.getBrandId() ? { filters: { brand: entity.getBrandId() } } : {}}
                  label={messages.model}
                  name="model"
                  value={{ value: entity.getModelId(), label: entity.getModelName() }}
                  meta={entity.getModelIdMetaInformation()}
                  validation={entity.getModelIdValidationResult()}
                  onChange={this.updateModel}
                  returnValueObject
                  autocompleteType="model"
                  disabled={disabled}
                />
                <FormInput
                  label={messages.name}
                  name="name"
                  value={entity.getName()}
                  meta={entity.getNameMetaInformation()}
                  validation={entity.getNameValidationResult()}
                  onChange={this.updateEntity}
                  disabled={disabled}
                />
                <FormInput
                  label={messages.vin}
                  name="vin"
                  value={entity.getVin()}
                  meta={entity.getVinMetaInformation()}
                  validation={entity.getVinValidationResult()}
                  onChange={this.updateVin}
                  disabled={disabled}
                />
                <FormInput
                  label={messages.license_plate_number}
                  name="licensePlateNumber"
                  value={entity.getLicensePlateNumber()}
                  meta={entity.getLicensePlateNumberMetaInformation()}
                  validation={entity.getLicensePlateNumberValidationResult()}
                  onChange={this.updateLicensePlateNumber}
                  disabled={disabled}
                />
                <FormInput
                  label={messages.mileage}
                  name="mileage"
                  value={entity.getMileage()}
                  meta={entity.getMileageMetaInformation()}
                  validation={entity.getMileageValidationResult()}
                  onChange={this.updateEntity}
                  disabled={disabled}
                  prefixAddon="km"
                />
              </div>
              <div className="text-right m-t-15">
                <Button
                  bsSize="lg"
                  disabled={formStatus.pending}
                  type="submit"
                  bsStyle={this.state.entityChanged ? 'primary' : 'default'}
                >
                  <i class={'fa-fw ' + (formStatus.pending ? ' fa fa-circle-notch fa-spin' : 'fal fa-save')} />{' '}
                  {messages.save}
                </Button>
              </div>
            </form>
          ) : (
            <Loader />
          )}
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    meta: state.entityMeta,
    user: state.login.user,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(ClientCarForm)));
